import React from "react";
//#region types
import { StyleEnums } from "models/enums";
//#endregion
//#region components
import { Grid } from "@mui/material";
import { StyledButton } from "components/common";
//#endregion
import cssExports from "theme/styles/main.module.scss";
import { LocalizationHelperInstance } from "utils/helpers";

interface AgentAction {
  labelKey: string;
  onClick: () => void;
  testId: string;
  disabled?: boolean;
  isSubmitting?: boolean;
}

interface AgentActionsProps {
  secondary?: AgentAction;
  primary: AgentAction;
}

const AgentActions: React.FC<AgentActionsProps> = ({ secondary, primary }) => (
  <Grid container className={cssExports.agentActions}>
    {secondary ? (
      <StyledButton
        size="sm"
        secondary
        disabled={secondary.disabled}
        onClick={secondary.onClick}
        testId={secondary.testId}
      >
        {LocalizationHelperInstance.getFormattedMessage(secondary.labelKey)}
      </StyledButton>
    ) : null}
    <StyledButton
      size="sm"
      displayType={StyleEnums.DisplayType.Info}
      disabled={primary.disabled}
      isSubmitting={primary.isSubmitting}
      onClick={primary.onClick}
      testId={primary.testId}
    >
      {LocalizationHelperInstance.getFormattedMessage(primary.labelKey)}
    </StyledButton>
  </Grid>
);

export default AgentActions;
